// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"e2255ea6","677":"0772c953"}[chunkId] + ".chunk.css";
};